import React from 'react';
import Tabs from './components/Tabs/Tabs';
import RestaurantFullInfoControlPanel from './components/RestaurantFullInfoControlPanel/RestaurantFullInfoControlPanel';

const RestaurantFullInfoModal: React.FC = () => {
	return (
		<>
			<RestaurantFullInfoControlPanel />
			<Tabs />
		</>
	);
};

export default RestaurantFullInfoModal;
